import { render, staticRenderFns } from "./OrderSearch.vue?vue&type=template&id=2c047141&scoped=true"
import script from "./OrderSearch.vue?vue&type=script&lang=js"
export * from "./OrderSearch.vue?vue&type=script&lang=js"
import style0 from "./OrderSearch.vue?vue&type=style&index=0&id=2c047141&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c047141",
  null
  
)

export default component.exports